export default function getExtensionIcon(ext) {
	switch (ext) {
		case 'wmv':
		case 'mkv':
		case 'mov':
		case 'video':
		case 'avi':
		case 'mp4':
			return {
				icon: 'fas fa-video',
				color: 'green-12',
			}

		case 'wav':
		case 'ogg':
		case 'audio':
		case 'mp3':
			return {
				icon: 'fas fa-headphones-alt',
				color: 'pink-12',
			}

		case 'pdf':
			return {
				icon: 'fas fa-file-pdf',
				color: 'red-12',
			}

		case 'png':
		case 'jpg':
		case 'jpeg':
		case 'gif':
			return {
				icon: 'fas fa-file-image',
				color: 'red-5',
			}

		case 'zip':
		case 'rar':
		case 'gzip':
		case 'tz':
			return { icon: 'fas fa-file-archive' }

		case 'docx':
		case 'doc':
			return { icon: 'fas fa-file-word' }

		case 'xlsx':
		case 'xls':
		case 'xlsb':
			return { icon: 'fas fa-file-excel' }

		case 'pptx':
		case 'ppt':
			return {
				icon: 'fas fa-file-powerpoint',
				color: 'orange-12',
			}

		case 'youtube':
			return {
				icon: 'fab fa-youtube',
				color: 'red-12',
			}

		case 'vimeo':
			return {
				icon: 'fab fa-vimeo',
				color: 'light-blue-12',
			}

		case 'webinar':
		case 'webcast':
		case 'wowza':
		case 'external_link':
			return { icon: 'fas fa-broadcast-tower' }

		case 'opened':
		case 'closed':
		case 'live_class':
		case 'opened':
		case 'closed':
		case 'live_class_opened':
		case 'live_class_closed':
			return {
				icon: 'fas fa-laptop',
				color: 'green-6',
			}

		case 'scorm':
		case 'scorm_cloud':
			return {
				icon: 'fas fa-chalkboard-teacher',
				color: 'teal-12',
			}

		case 'html':
			return {
				icon: 'fas fa-file-code',
				color: 'purple-12',
			}

		case 'flash':
			return { icon: 'fas fa-bolt' }

		case 'linkedin_slidshare':
			return {
				icon: 'fab fa-linkedin',
				color: 'blue-12',
			}

		case 'conventional_test':
		case 'restart_test':
		case 'restart_general_test':
		case 'block_general_test':
		case 'block_test':
			return {
				icon: 'fas fa-file-alt',
				color: 'teal-6',
			}

		case 'evaluated_quiz':
		case 'unevaluated_quiz':
			return {
				icon: 'fas fa-check-square',
				color: 'teal-9',
			}

		case 'presential_event':
			return {
				icon: 'fas fa-users',
				color: 'orange-13',
			}

		case 'reaction_evaluation':
			return {
				icon: 'fas fa-comment-dots',
				color: 'cyan-5',
			}

		case 'drag_and_drop':
		case 'drag_the_words':
		case 'fill_in_the_blanks':
		case 'find_the_pairs':
		case 'this_or_that':
		case 'true_or_false':
		case 'flashcards':
		case 'enigma':
			return {
				icon: 'fas fa-gamepad',
				color: 'deep-purple-11',
			}

		default:
			return {
				icon: 'fas fa-file',
				color: 'deep-purple-11',
			}
	}
}
